import { Routes } from '@angular/router';

import { RoleGuard } from '../../core/auth/role-guard';
import { noteRoutes } from './notes/note.routes';

export const marketsRoutes: Routes = [
  {
    path: 'markets',
    title: 'Markets',
    canActivate: [RoleGuard],
    data: {
      roles: [
        'SuperAdmin',
        'Markets.Admin',
        'Markets.Purchase',
        'Markets.Sales',
        'Markets.ProductDevelopment',
      ],
    },
    children: [
      ...noteRoutes,
      {
        path: 'purchase-planner',
        title: 'Purchase Planner',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Markets.Admin', 'Markets.Purchase'],
        },
        loadComponent: () =>
          import('./purchase-planner/pages/purchase-planner.component').then(
            module => module.PurchasePlannerComponent
          ),
      },
      {
        path: 'price-and-availability',
        title: 'Price and Availability',
        canActivate: [RoleGuard],
        data: {
          roles: [
            'SuperAdmin',
            'Markets.Admin',
            'Markets.Purchase',
            'Markets.Sales',
            'Markets.ProductDevelopment',
          ],
        },
        loadComponent: () =>
          import('./price-and-availability/pages/price-and-availability.component').then(
            module => module.PriceAndAvailabilityComponent
          ),
      },
      {
        path: 'sales/:id',
        title: 'Sales',
        canActivate: [RoleGuard],
        data: {
          roles: ['SuperAdmin', 'Markets.Admin', 'Markets.Sales'],
        },
        loadComponent: () =>
          import('./sales/pages/sales.component').then(module => module.SalesComponent),
      },
      {
        path: 'products',
        title: 'Product List',
        loadComponent: () =>
          import('./products/pages/product-list/product-list.component').then(
            module => module.ProductListComponent
          ),
      },
      {
        path: 'products/:id/overview',
        title: 'IPG overview',
        loadComponent: () =>
          import('./products/pages/product-overview/product-overview.component').then(
            module => module.ProductOverviewComponent
          ),
      },
      {
        path: 'drugs',
        title: 'Drug list',
        loadComponent: () =>
          import('./drugs/pages/drug-list/drug-list.component').then(
            module => module.DrugListComponent
          ),
      },
      {
        path: 'drugs/:id',
        title: 'Analysis',
        loadComponent: () =>
          import('./drugs/pages/drug-analysis/drug-analysis.component').then(
            module => module.DrugAnalysisComponent
          ),
      },
      {
        path: 'linking',
        title: 'Product Linking',
        loadComponent: () =>
          import('./linking/pages/linking/linking.component').then(
            module => module.LinkingComponent
          ),
      },
    ],
  },
];
